var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('SearchableCombo',{attrs:{"edit":false,"grp":0,"code":null,"rownumintable":3,"action":'TblCrmCombo/GetUserDatails',"method":'POST',"idinput":'UserId',"keyItem":'UserId0',"ClassProps":'required',"disabled":false},on:{"ResultCombo":_vm.getuserId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }